import { getAllClientProfiles } from "global/firestoreData/helpers/appProfileData";
import { useCallback, useContext, useEffect, useState } from "react";
import { DatabaseContext } from "../DatabaseContext";
import { ParentContext } from "../ParentContext";
import { _showAppLogs, LogContext } from "../LogContext";
import { showAppManagementTypes } from "global/cnr/reducers/AppUserManagementReducer";
import { _profileCollectionName } from "global/firestoreData/profiles/getProfile";
import { dataFix } from "global/common/dataFix";
import { createRefPath_client } from "global/firestoreData/appData/appRefPaths";
import { writeBatch } from "firebase/firestore";

export const useClientProfiles = ({ appManagementType }) => {

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext
  const { app_state, currentSettings_state, paps_state } = states
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state ?? {}

  const { aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection } = aps_appUserSettings ?? {}

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  const [clientProfiles, setClientProfiles] = useState()

  useEffect(() => {

    const getData = async () => {

      // 2️⃣ Listen for Firestore updates
      const cb = async (fetchedData) => {
        _showAppLogs.dbFetch && log_handlers.addLog(`🌐 Fetched data(${appUserCollection}) from Firebase`);
        console.log('fetchedData', fetchedData)
        setClientProfiles(fetchedData);
      };

      try {
        getAllClientProfiles(database_fns, pathViews, pathViews.events, appUserCollection, cb)
      } catch (err) {
        _showAppLogs.dbFetch && log_handlers.addLog(`❌ Failed to fetch data(${appUserCollection})`, err);
      }
    }

    switch (appManagementType) {
      case showAppManagementTypes.getClientProfiles:
        getData()
        break;
      default:
      // nothing
    }

  }, [appManagementType]);

  const updateClientProfiles = useCallback(
    async (clientProfiles, merge, remove) => {
      if (remove) {
        return removeClientProfiles(database_fns, mainDb, clientProfiles, pathViews)
      } else {
        return updateClient_profiles(database_fns, mainDb, clientProfiles, pathViews, merge);
      }
    },
    []
  );


  return { clientProfiles, updateClientProfiles };
};

const updateClient_profiles = async (database_fns, clientProfiles, pathViews, merge) => {

  const useTemp = false
  const collectionName = useTemp ? '_' + _profileCollectionName : _profileCollectionName

  const batch = writeBatch(mainDb);
  _.forEach(clientProfiles, (cp, key) => {
    const { email } = cp ?? {}
    delete cp._itemKey
    delete cp.intials
    const _cp = dataFix.removeAllEmpties(cp)
    const _refPath = createRefPath_client(pathViews, [collectionName, email])
    database_fns.set_doc(_refPath, _cp, merge, null, batch)
  })
  batch.commit()
}

const removeClientProfiles = async (database_fns, mainDb, clientProfiles, pathViews) => {

  const useTemp = false
  const collectionName = useTemp ? '_' + _profileCollectionName : _profileCollectionName

  const batch = writeBatch(mainDb);
  _.forEach(clientProfiles, (cp, key) => {
    delete cp._itemKey
    delete cp.intials
    const _refPath = createRefPath_client(pathViews, [collectionName, key])
    database_fns.delete_doc(_refPath, null, batch)
  })
  batch.commit()
}
